import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
// services
import { AuthenticationService } from '../service/auth.service';
import { decodeToken, getCurrentLanguage } from './utils';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Agregar cabecera de language
        request = request.clone({
            setHeaders: {
                'Accept-Language': getCurrentLanguage()
            }
        });


        // Add authorization header with jwt token if available
        // Si hay currentUser, significa que hay token y puedo hacer el decodeToken sobre el currentUser sin peligro de hacerlo sobre un null
        let token = decodeToken(sessionStorage.getItem('currentUser')!);
        if (token) {
            // Decodifica el token si es necesario o úsalo directamente
            // let decodedToken = decodeToken(token); // Si necesitas decodificar
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            });
        }

        return next.handle(request);
    }
}
